import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromContactDetails from '../../reducers/contact-details/contact-details.reducer';

export const selectContactDetailsState = createFeatureSelector<fromContactDetails.State>(
  fromContactDetails.contactDetailsFeatureKey
);

export const selectContactDetailsInfo = createSelector(
    selectContactDetailsState,
    (state: fromContactDetails.State) => ({
      // data: state.contactDetails,
      itemsPerPage: state.itemsPerPage,
      itemsPerPageList: [5,10, 25,100],
      totalItems: state.totalItems,
      // page: state.page,
    })
)

// Can't async pipe  data need this selector
export const selectContactDetailsData = createSelector(
    selectContactDetailsState,
    (state: fromContactDetails.State) => state.contacts
)

export const selectIsContactSaveDisabled = createSelector(
    selectContactDetailsState,
    (state: fromContactDetails.State) => {
        return state.isContactSaveDisabled;
    }
)
